import { useSessionContext } from '../context/SessionContext.js';
export function useSessionManager() {
    return useSessionContext();
}
//# sourceMappingURL=useSessionManager.js.map